import { render, staticRenderFns } from "./StoriesOverview.vue?vue&type=template&id=bc4b65a6"
import script from "./StoriesOverview.vue?vue&type=script&lang=ts"
export * from "./StoriesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports